// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3sy1G","content":"classes_content__QQXnH"};